<script>
    import { slide } from 'svelte/transition';

    export let state;
    export let info;

    export let values = {};
    export let frozenValues = {};

    let calculated;
    $: calculated = state === 'CALCULATED';

    let validated;
    $: validated = (values.smoking !== null)
        && (values.recall !== null)
        && (values.systemic !== null)
        && (values.location !== null)
        && (values.edentulism
            ||
            ((values.edentulism === false)
                && (values.teeth_lost !== null)
                && (values.fmbs !== null)
                && (values.ppd !== null)
                && ((values.perio === false)
                    || (values.perio
                        && (values.age !== null)
                        && (values.bone_loss !== null)))));

    function resetPerioValues(perio) {
        if (perio) {
            values.age = null;
            values.bone_loss = null;
        } else {
            values.age = 18;
            values.bone_loss = 0;
        }

        return true;
    }

    function calculateRisk(_) {
        Object.assign(frozenValues, values);
        state = 'CALCULATED';
    }

    function initValues() {
        values.smoking = null;
        values.recall =  null;
        values.systemic = null;
        values.location = null;

        values.edentulism = false;
        values.teeth_lost = null;
        values.fmbs = null;
        values.ppd = null;

        values.perio = null;
        values.age = null;
        values.bone_loss = null;
    }

    function resetValues() {
        initValues();
        state = "PARTIAL";
    }

    function showInfo(e) {
        info = e.target.id;
    }

    initValues();
</script>

<div class="card">
    <div class="card-content">
        <div class="content">
            <div id="smoking" class="field is-horizontal" class:modifiable={calculated} on:mouseenter={showInfo}>
                <div class="field-label is-normal">
                    <label class="label" for="smoking">Smoking</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div id="smoking-input" class="control">
                            <input id="smoking-field" class="slider has-output" bind:value={values.smoking} step="1" min="0" max="40" type="range">
                            <output for="smoking-field">{values.smoking === null? '?' : values.smoking}</output>
                        </div>
                        <p class="help">cigarettes/day</p>
                    </div>
                </div>
            </div>

            <div id="recall" class="field is-horizontal" class:modifiable={calculated} on:mouseenter={showInfo}>
                <div class="field-label is-normal">
                    <label class="label" for="recall">Recall interval</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div id="recall-input" class="control">
                            <input class="slider has-output" bind:value={values.recall} step="1" min="3" max="24" type="range">
                            <output for="recall">{values.recall === null? '?' : values.recall}</output>
                        </div>
                        <p class="help">months</p>
                    </div>
                </div>
            </div>

            <div id="systemic" class="field is-horizontal" on:mouseenter={showInfo}>
                <div class="field-label">
                    <label class="label" for="systemic">General health</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="is-checkradio is-small"
                                   bind:group={values.systemic} value={false}
                                   disabled={calculated}
                                   id="systemic-false" type="radio" name="systemic">
                            <label for="systemic-false">Healthy</label>

                            <input class="is-checkradio is-small"
                                   bind:group={values.systemic} value={true}
                                   disabled={calculated}
                                   id="systemic-true" type="radio" name="systemic">
                            <label for="systemic-true">Systemic/genetic disease</label>
                        </div>
                    </div>
                </div>
            </div>

            <div id="location" class="field is-horizontal" on:mouseenter={showInfo}>
                <div class="field-label">
                    <label class="label" for="location">Implant location</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="is-checkradio is-small"
                                   bind:group={values.location} value="upper"
                                   disabled={calculated}
                                   id="location-upper" type="radio" name="location">
                            <label for="location-upper">Upper jaw</label>

                            <input class="is-checkradio is-small"
                                   bind:group={values.location} value="lower"
                                   disabled={calculated}
                                   id="location-lower" type="radio" name="location">
                            <label for="location-lower">Lower jaw</label>
                        </div>
                    </div>
                </div>
            </div>

            <div id="edentulism" class="field is-horizontal" on:mouseenter={showInfo}>
                <div class="field-label">
                    <label class="label" for="edentulism">Edentulism?</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="is-checkradio is-small"
                                   bind:group={values.edentulism} value={false}
                                   disabled
                                   id="edentulism-false" type="radio" name="edentulism">
                            <label for="edentulism-false">Partial</label>

                            <input class="is-checkradio is-small"
                                   bind:group={values.edentulism} value={true}
                                   disabled
                                   id="edentulism-true" type="radio" name="edentulism">
                            <label for="edentulism-true">Full</label>
                        </div>
                    </div>
                </div>
            </div>

            {#if (values.edentulism === false)}
                <div transition:slide>
                    <div id="missing" class="field is-horizontal" on:mouseenter={showInfo}>
                        <div class="field-label">
                            <label class="label" for="missing">Teeth lost</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div id="missing-input" class="control">
                                    <input class="slider has-output" bind:value={values.teeth_lost} step="1" min="1" max="28" type="range" disabled={calculated}>
                                    <output for="missing">{values.teeth_lost === null? '?' : values.teeth_lost}</output>
                                </div>
                                <p class="help">Number of teeth</p>
                            </div>
                        </div>
                    </div>

                    <div id="fmbs" class="field is-horizontal" class:modifiable={calculated} on:mouseenter={showInfo}>
                        <div class="field-label">
                            <label class="label" for="fmbs">Full mouth<br>bleeding score</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div id="fmbs-input" class="control">
                                    <input class="slider has-output" bind:value={values.fmbs} step="1" min="0" max="100" type="range">
                                    <output for="fmbs">{values.fmbs === null? '?' : values.fmbs}</output>
                                </div>
                                <p class="help">Percentage</p>
                            </div>
                        </div>
                    </div>

                    <div id="ppd" class="field is-horizontal" class:modifiable={calculated} on:mouseenter={showInfo}>
                        <div class="field-label">
                            <label class="label" for="ppd">PPD &geq; 5mm</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div id="ppd-input" class="control">
                                    <input class="slider has-output" bind:value={values.ppd} step="1" min="0" max="27" type="range">
                                    <output for="ppd">{values.ppd === null? '?' : values.ppd}</output>
                                </div>
                                <p class="help">Number of teeth</p>
                            </div>
                        </div>
                    </div>

                    <div id="perio" class="field is-horizontal" transition:slide on:mouseenter={showInfo}>
                        <div class="field-label">
                            <label class="label" for="perio">History of periodontitis?</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="is-checkradio is-small"
                                           bind:group={values.perio} value={false}
                                           disabled={calculated}
                                           id="exampleRadioSmall7" type="radio" name="perio">
                                    <label for="exampleRadioSmall7"
                                           on:click={e => resetPerioValues(false)}>No</label>

                                    <input class="is-checkradio is-small"
                                           bind:group={values.perio} value={true}
                                           disabled={calculated === true}
                                           id="exampleRadioSmall8" type="radio" name="perio">
                                    <label for="exampleRadioSmall8"
                                           on:click={e => resetPerioValues(true)}>Yes</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {#if (values.perio === true)}
                    <div transition:slide>
                        <div id="age" class="field is-horizontal" on:mouseenter={showInfo}>
                            <div class="field-label">
                                <label class="label" for="age">Age</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div id="age-input" class="control">
                                        <input class="slider has-output" bind:value={values.age} step="1" min="18" max="120" type="range" disabled={calculated}>
                                        <output for="age">{values.age === null? '?' : values.age}</output>
                                    </div>
                                    <p class="help">years</p>
                                </div>
                            </div>
                        </div>

                        <div id="boneloss" class="field is-horizontal" on:mouseenter={showInfo}>
                            <div class="field-label">
                                <label class="label" for="boneloss">Alveolar bone loss</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div id="boneloss-input" class="control">
                                        <input class="slider has-output" bind:value={values.bone_loss} step="1" min="0" max="100" type="range" disabled={calculated}>
                                        <output for="boneloss">{values.bone_loss === null? '?' : values.bone_loss}</output>
                                    </div>
                                    <p class="help">Percentage</p>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
            {/if}

            <div id="toolbar" class="field is-grouped is-grouped-centered is-hidden-print">
                <p class="control">
                    <button class="button is-primary"
                            id="calculate-button" on:mouseenter={showInfo}
                            on:click={calculateRisk}
                            disabled={calculated || !validated}>
                        Calculate risk
                    </button>
                </p>
                <p class="control">
                    <button class="button"
                            id="reset-button" on:mouseenter={showInfo}
                            on:click={resetValues}>
                        Reset
                    </button>
                </p>
            </div>
        </div>
    </div>
</div>

<style>
    input.slider {
        margin: 0 !important;
    }

    .modifiable {
        background-color: rgb(0, 209, 178, 0.1);
    }

    .field-label {
        min-width: 8.5rem;
    }

    #toolbar {
        margin-top: 1rem;
    }
</style>